import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useRef, useEffect } from "react";
export function UserMenu({ auth, onShowStats, onShowLeaderboard }) {
    const [open, setOpen] = useState(false);
    const menuRef = useRef(null);
    // Close on outside click
    useEffect(() => {
        const handler = (e) => {
            if (menuRef.current && !menuRef.current.contains(e.target)) {
                setOpen(false);
            }
        };
        document.addEventListener("mousedown", handler);
        return () => document.removeEventListener("mousedown", handler);
    }, []);
    if (!auth.isAuthenticated || !auth.user)
        return null;
    const { user } = auth;
    const initials = user.display_name
        .split(" ")
        .map((w) => w[0] ?? "")
        .slice(0, 2)
        .join("")
        .toUpperCase();
    return (_jsxs("div", { className: "user-menu", ref: menuRef, children: [_jsx("button", { className: "avatar-btn", onClick: () => setOpen((o) => !o), "aria-label": "User menu", "aria-expanded": open, children: user.avatar_url ? (_jsx("img", { src: user.avatar_url, alt: user.display_name, className: "avatar-img" })) : (_jsx("span", { className: "avatar-initials", children: initials })) }), open && (_jsxs("div", { className: "user-dropdown", role: "menu", children: [_jsx("div", { className: "user-dropdown-header", children: _jsx("span", { className: "user-name", children: user.display_name }) }), _jsx("hr", { className: "dropdown-divider" }), _jsx("button", { className: "dropdown-item", role: "menuitem", onClick: () => { setOpen(false); onShowStats(); }, children: "\uD83D\uDCCA My Stats" }), _jsx("button", { className: "dropdown-item", role: "menuitem", onClick: () => { setOpen(false); onShowLeaderboard(); }, children: "\uD83C\uDFC6 Leaderboard" }), _jsx("hr", { className: "dropdown-divider" }), _jsx("button", { className: "dropdown-item danger", role: "menuitem", onClick: () => { setOpen(false); auth.signOut(); }, children: "Sign out" })] }))] }));
}
